import type { ReactNode } from 'react';

import { CloseButton } from '#src/atoms/buttons/CloseButton/index.tsx';
import { DialogContentWithNavigation } from '#src/components/dialog/DialogContentWithNavigation/index.tsx';
import type { Props as DialogProps } from '#src/components/dialog/index.tsx';
import { Dialog } from '#src/components/dialog/index.tsx';

type Props = DialogProps & {
  title?: ReactNode;
  right?: ReactNode;
  children: ReactNode;
  onBackButton?: () => void;
};
export const DialogWithNavigation = (props: Props) => {
  const { children, onBackButton, title, right, onClose, ...dialogProps } =
    props;
  return (
    <Dialog maxWidth="xs" fullWidth {...dialogProps} hideHeader>
      <DialogContentWithNavigation
        title={title}
        onBackButton={onBackButton}
        right={
          onClose ? <CloseButton size="medium" onClose={onClose} /> : undefined
        }
        noPadding
      >
        {children}
      </DialogContentWithNavigation>
    </Dialog>
  );
};
